
import { ThemeEvents, CartUpdateEvent } from '@theme/events';

const STORAGE_KEY = 'freeGiftState';
window.enableGiftthreshold = true;

window.FREE_GIFT_MODE = window.FREE_GIFT_MODE || 'threshold';
// 'popup' = old auto popup flow
// 'threshold' = new Gift Threshold flow

window.FREE_GIFT_THRESHOLDS = window.FREE_GIFT_THRESHOLDS || {
  DKK: 2500, EUR: 400, GBP: 400, USD: 450, SEK: 3700, NOK: 3000,
  CHF: 400, AUD: 800, CAD: 600, CNY: 4300, HKD: 3600,
  JPY: 85000, KRW: 860000, MXN: 12500, PLN: 1900,
  SAR: 2100, AED: 1800, SGD: 600
};

let cartRequest = null;
let giftTimer = null;

/* STORAGE */
window.getGiftState = function () {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

window.setGiftState = function (next) {
  const prev = window.getGiftState();
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...prev, ...next }));
};

window.resetGiftState = function () {
  localStorage.removeItem(STORAGE_KEY);
};

/* CART */
window.getCartFresh = async function () {
  if (cartRequest) return cartRequest;

  cartRequest = fetch('/cart.js', {
    headers: { Accept: 'application/json' },
    cache: 'no-store'
  })
    .then(res => {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    })
    .catch(err => {
      console.error('[FreeGift] Cart fetch error:', err);
      return null;
    })
    .finally(() => {
      cartRequest = null;
    });

  return cartRequest;
};

/* HELPERS */
function getCurrency() {
  return (
    window.Shopify?.currency?.active ||
    window.Shopify?.checkout?.currency ||
    localStorage.getItem('currencyCode') ||
    'USD'
  );
}

function isGiftUnlocked() {
  const cart = window.currentCartData;

  if (!cart) return false;

  const progress = getGiftProgress(cart);

  return progress.unlocked;
}

function getThreshold() {
  const currency = getCurrency();
  return window.FREE_GIFT_THRESHOLDS[currency] || window.FREE_GIFT_THRESHOLDS.USD;
}

function formatMoney(amount) {
  return `${getCurrency()} ${Math.ceil(amount).toLocaleString()}`;
}

function findGift(cart) {
  return cart?.items?.find(item => item.properties?._free_gift === 'Yes');
}

function getPaidItems(cart) {
  return (cart?.items || []).filter(item => item.properties?._free_gift !== 'Yes');
}

function getPaidSubtotal(cart) {
  return getPaidItems(cart).reduce((sum, item) => sum + item.final_line_price, 0) / 100;
}

function getGiftProgress(cart) {
  const threshold = getThreshold();
  const subtotal = getPaidSubtotal(cart);
  const remaining = Math.max(threshold - subtotal, 0);
  const percent = Math.min((subtotal / threshold) * 100, 100);
  const unlocked = subtotal >= threshold;
  if (!unlocked) {
   addFreeProducts();
  }else{
    removeFreeProducts();
  }
  return {
    threshold,
    subtotal,
    remaining,
    percent,
    unlocked
  };
}

/* POPUP */
window.closePopup = function () {
  document.querySelector('#free-gift-dialog dialog')?.close();
};

window.isKlaviyoOpen = function () {
  return !!document.querySelector('[data-testid="POPUP"]');
};

window.waitForKlaviyoToClose = function (callback) {
  const interval = setInterval(() => {
    if (!window.isKlaviyoOpen()) {
      clearInterval(interval);
      callback();
    }
  }, 300);
};

// window.checkAndOpenGiftPopup = async function () {
//   if (window.FREE_GIFT_MODE !== 'threshold') return false;

//   const cart = window.currentCartData || await window.getCartFresh();

//   if (!cart) return false;

//   window.currentCartData = cart;

//   const progress = getGiftProgress(cart);
//   const existingGift = findGift(cart);
//   const giftState = window.getGiftState();
 
//   if (
//     progress.unlocked &&
//     !existingGift &&
//     !giftState.popupShown &&
//     !giftState.removedManually
//   ) {
//     window.setGiftState({
//       popupShown: true
//     });

//     window.openPopup();
//     return true;
//   }

//   return false;
// };

let giftPopupOpening = false;

window.checkAndOpenGiftPopup = async function () {
  if (window.FREE_GIFT_MODE !== 'threshold') return false;
  if (giftPopupOpening) return false;

  const cart =
    window.currentCartData ||
    await window.getCartFresh();

  if (!cart) return false;

  window.currentCartData = cart;

  const progress = getGiftProgress(cart);
  const existingGift = findGift(cart);
  const giftState = window.getGiftState();

  // Customer is below the threshold.
  if (!progress.unlocked) {
    return false;
  }

  const justUnlocked =
    giftState.thresholdUnlocked !== true;

  // Record the threshold state immediately.
  window.setGiftState({
    thresholdUnlocked: true
  });

  if (
    !justUnlocked ||
    existingGift ||
    giftState.popupShown ||
    giftState.removedManually
  ) {
    return false;
  }

  giftPopupOpening = true;

  window.setGiftState({
    popupShown: true,
    thresholdUnlocked: true
  });

  try {
    return window.openPopup();
  } finally {
    setTimeout(() => {
      giftPopupOpening = false;
    }, 500);
  }
};

function removeFreeProducts() {
  const elements = document.querySelectorAll('.add-fre-prdt');
  elements.forEach(el => {
    el.classList.remove('free-products');
  });
}
function addFreeProducts() {
  const elements = document.querySelectorAll('.add-fre-prdt');

  elements.forEach(el => {
    el.classList.add('free-products');
  });
}

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('.gift-floating-btn, .ayf-gift');

  if (!btn) return;

  e.preventDefault();

  const cart = window.currentCartData || await window.getCartFresh();

  if (!cart) return;

  const progress = getGiftProgress(cart);

  if (progress.unlocked) {

    // Open existing gift selector popup
    window.openPopup();

  } else {

    // Open threshold popup
    document
      .querySelector('#freeGiftToast')
      ?.classList.add('is-visible');

  }

});

// window.openPopup = function () {
//   const dialog = document.querySelector('#free-gift-dialog dialog');

//   if (!dialog) {
//     console.warn('[FreeGift] Popup not found');
//     return false;
//   }

//   if (window.isKlaviyoOpen()) {
//     window.waitForKlaviyoToClose(() => dialog.showModal());
//     return false;
//   }

//   dialog.showModal();
//   return true;
// };
window.openPopup = function () {
  const dialog =
    document.querySelector('#free-gift-dialog dialog');

  if (!dialog) {
    console.warn('[FreeGift] Popup not found');
    return false;
  }

  // Do not call showModal again when already open.
  if (dialog.open) {
    return false;
  }

  if (window.isKlaviyoOpen()) {
    window.waitForKlaviyoToClose(() => {
      if (!dialog.open) {
        dialog.showModal();
      }
    });

    return false;
  }

  dialog.showModal();
  return true;
};


/* UI */
function updateGiftText(cart) {

  if (window.FREE_GIFT_MODE !== 'threshold') return;
  const progress = getGiftProgress(cart);

  const buttons = document.querySelectorAll('.add-to-cart-button');

  if (!buttons.length) {
    console.warn('No buttons found with class .add-to-cart-button');
    return;
  }

  setTimeout(() => {
    document.querySelectorAll('.add-to-cart-button').forEach(btn => {
      const isFreeProduct = btn.dataset.freeProduct === 'true';

      if (!isFreeProduct) {
        btn.classList.remove('free-products');
        return;
      }
      
      if (progress.subtotal <= progress.threshold) {

        btn.classList.add('free-products');

        // Mark customVariant as disabled
        const customVariantBtn = document.querySelector('#customVariant');

        if (customVariantBtn) {
          customVariantBtn.dataset.disabled = 'true';
        }

      } else {

        btn.classList.remove('free-products');

        // Enable customVariant again
        const customVariantBtn = document.querySelector('#customVariant');

        if (customVariantBtn) {
          customVariantBtn.dataset.disabled = 'false';
        }
      }

    });
  }, 200);

  // Main Message

  document.querySelectorAll('.prochnage').forEach(el => {

    if (progress.unlocked) {

      el.innerHTML = `You've unlocked your complimentary Drawstring Bag — <a href="#" class="normal_to_anchor m--0 lh1.5 border-bottom">choose your color</a>.`;

    } else {

      el.innerHTML =
        `You're <strong>${formatMoney(progress.remaining)}</strong> away from your complimentary Drawstring Bag.`;

    }

  });

  // Threshold Message

  document.querySelectorAll('.prochnagde').forEach(el => {

    el.innerHTML =
      `Complimentary HANNE BLOCH Drawstring Bag on orders over <strong>${formatMoney(progress.threshold)}</strong>.`;

  });

  // Progress Fill

  document.querySelectorAll('[data-gift-progress-fill]').forEach(el => {

    el.style.width = `${progress.percent}%`;
    el.style.display = 'block';

  });

  // Progress Numbers

  document.querySelectorAll('.free-gift-toast__price').forEach(el => {

    el.innerHTML =
      `${formatMoney(progress.subtotal)} / ${formatMoney(progress.threshold)}`;

  });

  // Hide Progress When Unlocked

  document.querySelectorAll('.prgr-bar-rmve').forEach(el => {

    el.style.display =
      progress.unlocked ? 'none' : '';

  });

  // Floating Button Text

  const buttonText =
    document.querySelector('.gift-txt-btn');

  if (buttonText) {

    if (progress.unlocked) {

      buttonText.textContent =
        'Gift unlocked';

    } else if (cart.item_count > 0) {

      buttonText.textContent =
        `${formatMoney(progress.remaining)} away from your gift`;

    } else {

      buttonText.textContent =
        'A gift for you';

    }

  }

  document.body.classList.toggle(
    'gift-threshold-unlocked',
    progress.unlocked
  );

}


document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('.popup__close_threshold');
  if (!closeBtn) return;
  document .querySelector('#freeGiftToast')?.classList.remove('is-visible');
});

/* REMOVE GIFT */
async function removeGift(cart) {
  const gift = findGift(cart);
  if (!gift) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: gift.key,
      quantity: 0
    })
  });

  window.setGiftState({
    added: false,
    removedManually: true
  });

  document.dispatchEvent(
    new CartUpdateEvent({ source: 'free-gift-auto-remove' })
  );
}

/* ADD GIFT */
async function addSelectedGift() {
  const selected = document.querySelector('.gift-radio:checked');

  if (!selected?.value) {
    alert('Please select a free gift');
    return;
  }

  const cart = await window.getCartFresh();
  if (!cart) return;

  if (window.FREE_GIFT_MODE === 'threshold') {
    const progress = getGiftProgress(cart);

    if (!progress.unlocked) {
      console.warn('[FreeGift] Threshold not reached');
      return;
    }
  }

  const existingGift = findGift(cart);

  if (existingGift) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: existingGift.key,
        quantity: 0
      })
    });
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: selected.value,
      quantity: 1,
      properties: { _free_gift: 'Yes' }
    })
  });

  if (!res.ok) throw new Error('Gift add failed');

  window.setGiftState({
    added: true,
    removedManually: false,
    popupShown: true
  });

  window.closePopup();

  document.dispatchEvent(
    new CartUpdateEvent({ source: 'free-gift-added' })
  );
}

/* OLD POPUP LOGIC */
async function runPopupMode(cart) {
  const state = window.getGiftState();
  const gift = findGift(cart);
  const paidCount = getPaidItems(cart).length;

  if (cart.item_count === 0) {
    window.resetGiftState();
    return;
  }

  if (paidCount > 0 && state.added && !gift) {
    window.setGiftState({ removedManually: true });
  }

  if (!state.paidProductAdded && paidCount > 0) {
    window.setGiftState({ paidProductAdded: true });

    if (gift) {
      window.setGiftState({ added: true });
      return;
    }

    if (!state.removedManually && !state.popupShown) {
      if (window.openPopup()) {
        window.setGiftState({ popupShown: true });
      }
    }
  }

  if (paidCount === 0 && gift) {
    await removeGift(cart);
  }
}

/* NEW THRESHOLD LOGIC */
// async function runThresholdMode(cart) {
//   const progress = getGiftProgress(cart);
//   const gift = findGift(cart);

//   updateGiftText(cart);

//   if (cart.item_count === 0) {
//     window.resetGiftState();
//     return;
//   }

//   // Prevent popup state in threshold mode
//   window.setGiftState({
//     popupShown: false
//   });

//   if (!progress.unlocked && gift) {
//     await removeGift(cart);
//   }
// }
async function runThresholdMode(cart) {
  const progress = getGiftProgress(cart);
  const gift = findGift(cart);

  updateGiftText(cart);

  if (cart.item_count === 0) {
    window.resetGiftState();
    return;
  }

  // Only reset the popup when the customer falls below
  // the threshold after previously unlocking it.
  if (!progress.unlocked) {
    const state = window.getGiftState();

    if (state.thresholdUnlocked) {
      window.setGiftState({
        thresholdUnlocked: false,
        popupShown: false
      });
    }

    if (gift) {
      await removeGift(cart);
    }
  }
}

/* MAIN */
async function runFreeGiftLogic() {
  const cart = await window.getCartFresh();
  if (!cart?.items) return;
  window.currentCartData = cart;
  if (window.FREE_GIFT_MODE === 'threshold') {
    await runThresholdMode(cart);
    window.checkAndOpenGiftPopup();
  } else {
    await runPopupMode(cart);
  }
}

function scheduleFreeGiftLogic(delay = 300) {
  clearTimeout(giftTimer);
  giftTimer = setTimeout(runFreeGiftLogic, delay);
}

/* EVENTS */
document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('drawstring') === 'open') {
    window.openPopup();
    return;
  }

  if (window.FREE_GIFT_MODE === 'popup') {
    const delay = window.FREE_GIFT_DELAY ?? 10;

    setTimeout(async () => {
      const state = window.getGiftState();
      const cart = await window.getCartFresh();

      if (!cart || state.popupShown) return;

      if (window.openPopup()) {
        window.setGiftState({ popupShown: true });
      }
    }, delay * 1000);
  }

  // scheduleFreeGiftLogic(100);
});

document.addEventListener(ThemeEvents.cartUpdate, () => {
   if(window.enableGiftthreshold === true){
    scheduleFreeGiftLogic(300);
  }
});

document.addEventListener('cart:updated', () => {
  if(window.enableGiftthreshold === true){
    scheduleFreeGiftLogic(300);
  }
});

document.addEventListener('cart:quantity-updated', () => {
   if(window.enableGiftthreshold === true){
    scheduleFreeGiftLogic(300);
  }
});

document.addEventListener('cart:added', () => {
  if(window.enableGiftthreshold === true){
    scheduleFreeGiftLogic(300);
  }
});

/* MANUAL POPUP OPEN */
document.addEventListener('click', e => {
  const btn = e.target.closest(
    '#open-free-gift-popup, .change-gift, .normal_to_anchor, [data-gift-open]'
  );

  if (!btn) return;

  e.preventDefault();

  window.setGiftState({
    removedManually: false,
    popupShown: true
  });

  window.openPopup();
});

/* ADD GIFT BUTTON */
document.addEventListener('click', async e => {
  const addBtn = e.target.closest('#free-gift-dialog .add-to-cart-button, .mother-gift-btn');

  if (!addBtn) return;

  e.preventDefault();

  try {
    addBtn.disabled = true;
    addBtn.classList.add('atc-added');

    await addSelectedGift();

  } catch (err) {
    console.error('[FreeGift] Add error:', err);
  } finally {
    addBtn.disabled = false;
    addBtn.classList.remove('atc-added');
  }
});

/* GIFT VARIANT SELECT */
document.addEventListener('change', e => {
  const select = e.target.closest('.gift-variant-select');
  if (!select) return;

  const card = select.closest('.gift-card');
  const radio = card?.querySelector('.gift-radio');
  const option = select.options[select.selectedIndex];

  if (!radio || !option) return;

  if (option.disabled) {
    radio.disabled = true;
    radio.checked = false;
  } else {
    radio.disabled = false;
    radio.checked = true;
    radio.value = option.value;
  }
});

/* MANUAL REMOVE FLAG */
document.addEventListener('click', e => {
  if (!e.target.closest('.fr-prdt-rmv')) return;

  window.setGiftState({
    added: false,
    removedManually: true
  });
});



// Header Swatch
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".color-slider");
  const nextBtn = document.querySelector(".color-nav.next");
  const prevBtn = document.querySelector(".color-nav.prev");
  const sliderWraper = document.querySelector(".color-slider-wrapper");

  if (!slider || !nextBtn || !prevBtn) return;

  const scrollAmount = 72;

  function updateButtons() {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

    // LEFT
    if (slider.scrollLeft <= 2) {
      prevBtn.classList.add("hidden");
      sliderWraper.classList.add("hide-prev");
    } else {
      prevBtn.classList.remove("hidden");
      sliderWraper.classList.remove("hide-prev");
    }

    // RIGHT
    if (slider.scrollLeft >= maxScrollLeft - 2) {
      nextBtn.classList.add("hidden");
      sliderWraper.classList.add("hide-next");
    } else {
      nextBtn.classList.remove("hidden");
     sliderWraper.classList.remove("hide-next");
    }
  }

  function checkOverflow() {
    const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;

    if (hasOverflow) {
      nextBtn.classList.remove("hidden");
      slider.classList.remove("hide-next");
    } else {
      nextBtn.classList.add("hidden");
      prevBtn.classList.add("hidden");
      slider.classList.remove("hide-prev");
      slider.classList.remove("hide-next");
    }
  }

  function init() {
    checkOverflow();
    updateButtons();
  }

  nextBtn.addEventListener("click", () => {
    slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  prevBtn.addEventListener("click", () => {
    slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  slider.addEventListener("scroll", updateButtons);

  // ✅ ONLY ONE reliable init trigger
  window.addEventListener("load", () => {
    init();
  });

  // ✅ Resize fix
  window.addEventListener("resize", init);

  // ✅ BEST FIX (handles image load + layout changes perfectly)
  // const observer = new ResizeObserver(() => {
  //   init();
  // });

  // observer.observe(slider);

}); 


// New Product Template Tabs
document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".product-tabs-component").forEach((component) => {

    const nav = component.querySelector("[data-tabs-nav]");
    const content = component.querySelector("[data-tabs-content]");

    if (!nav || !content) return;

    const items = content.querySelectorAll(".product-tab-item");

    items.forEach((item, index) => {

      const button = item.querySelector(".product-tab-pill");
      const panel = item.querySelector(".product-tab-panel");

      if (!button || !panel) return;

      // Move pills into top nav
      nav.appendChild(button);

      // First active
      if (index === 0) {

        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        panel.classList.add("active");
        panel.hidden = false;

      } else {

        button.setAttribute("aria-selected", "false");
        button.setAttribute("tabindex", "-1");

        panel.hidden = true;

      }

      button.addEventListener("click", () => {

        const targetId = button.dataset.tabTrigger;

        // Reset buttons
        nav.querySelectorAll(".product-tab-pill").forEach((pill) => {

          pill.classList.remove("active");
          pill.setAttribute("aria-selected", "false");
          pill.setAttribute("tabindex", "-1");

        });

        // Reset panels
        content.querySelectorAll(".product-tab-panel").forEach((tabPanel) => {

          tabPanel.classList.remove("active");
          tabPanel.hidden = true;

        });

        // Active button
        button.classList.add("active");
        button.setAttribute("aria-selected", "true");
        button.setAttribute("tabindex", "0");

        // Active panel
        const activePanel = content.querySelector(`#${targetId}`);

        if (activePanel) {

          activePanel.classList.add("active");
          activePanel.hidden = false;

        }

        // Smooth scroll active pill
        button.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });

      });

      // Keyboard support
      button.addEventListener("keydown", (event) => {

        const tabs = [...nav.querySelectorAll(".product-tab-pill")];

        const currentIndex = tabs.indexOf(button);

        let nextIndex = currentIndex;

        switch (event.key) {

          case "ArrowRight":
            nextIndex = (currentIndex + 1) % tabs.length;
            break;

          case "ArrowLeft":
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            nextIndex = 0;
            break;

          case "End":
            nextIndex = tabs.length - 1;
            break;

          default:
            return;

        }

        event.preventDefault();

        tabs[nextIndex].focus();
        tabs[nextIndex].click();

      });

    });

    // Mouse wheel horizontal scroll
    nav.addEventListener("wheel", (event) => {

      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {

        event.preventDefault();

        nav.scrollLeft += event.deltaY;

      }

    }, { passive: false });

    component.classList.add("tabs-ready");

  });

});


// Delivery Dates
(function() {

    let isUpdating = false;

    async function updateDeliveryDate() {

        if (isUpdating) return;

        const elements = document.querySelectorAll('.custom-delivery-date');

        if (!elements.length) return;

        isUpdating = true;

        try {

            /*
            ============================================
            SHIPPING MATRIX
            ============================================
            */

            const SHIPPING_RULES = {
                DKK: { min: 1, max: 2 },
                EUR: { min: 1, max: 2 },
                GBP: { min: 1, max: 3 },
                CHF: { min: 1, max: 3 },
                SEK: { min: 1, max: 2 },
                NOK: { min: 1, max: 2 },
                PLN: { min: 1, max: 2 },

                AED: { min: 1, max: 3 },
                SAR: { min: 1, max: 3 },

                CAD: { min: 1, max: 3 },

                MXN: { min: 2, max: 4 },

                AUD: { min: 2, max: 4 },
                HKD: { min: 2, max: 4 },
                SGD: { min: 2, max: 4 },
                JPY: { min: 2, max: 4 },
                KRW: { min: 2, max: 4 },
                CNY: { min: 2, max: 4 }
            };

            /*
            ============================================
            GET SHOPIFY MARKET CURRENCY
            ============================================
            */

            let currency = 'USD';

            if (window.Shopify?.currency?.active) {
                currency = Shopify.currency.active;
            } else if (window.Shopify?.checkout?.currency) {
                currency = Shopify.checkout.currency;
            }

            /*
            ============================================
            GEO IP LOOKUP
            ============================================
            */

            function getUserCountry() {
              try {
                const cachedCountry = localStorage.getItem("user_country");
                const cachedTime = localStorage.getItem("user_country_time");

                if (
                  cachedCountry &&
                  cachedTime &&
                  Date.now() - parseInt(cachedTime, 10) < 86400000
                ) {
                  return cachedCountry;
                }

                const country =
                  window.HBLocalization?.country ||
                  window.Shopify?.country ||
                  "US";

                const finalCountry = country.toUpperCase();

                localStorage.setItem("user_country", finalCountry);
                localStorage.setItem("user_country_time", Date.now().toString());

                return finalCountry;
              } catch (e) {
                return "US";
              }
            }

            const userCountry =  getUserCountry();

            /*
            ============================================
            SHIPPING RANGE
            ============================================
            */

            function getShippingRange(currency, country) {

                /*
                USD SPECIAL LOGIC
                */

                if (currency === 'USD') {

                    return country === 'US'
                        ? { min: 1, max: 3 }
                        : { min: 2, max: 4 };
                }

                /*
                STANDARD RULES
                */

                if (SHIPPING_RULES[currency]) {
                    return SHIPPING_RULES[currency];
                }

                /*
                FALLBACK
                */

                return { min: 2, max: 4 };
            }

            const shippingRange = getShippingRange(currency, userCountry);

            /*
            ============================================
            HOLIDAYS
            ONLY FOR SHIPPING DATE
            ============================================
            */

            async function getHolidays(countryCode) {

                if (!countryCode) return [];

                const year = new Date().getFullYear();

                const cacheKey = `holidays_${countryCode}_${year}`;

                const cached = localStorage.getItem(cacheKey);

                if (cached) {
                    return JSON.parse(cached);
                }

                try {

                    const response = await fetch(
                        `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`
                    );

                    if (!response.ok) return [];

                    const data = await response.json();

                    const dates = data.map(h => h.date);

                    localStorage.setItem(cacheKey, JSON.stringify(dates));

                    return dates;

                } catch (e) {

                    return [];
                }
            }

            /*
            SHIPPING COUNTRY
            Denmark warehouse
            */

            const holidays = await getHolidays('DK');

            /*
            ============================================
            HELPERS
            ============================================
            */

            function isWeekend(date) {

                const day = date.getDay();

                return day === 0 || day === 6;
            }

            function isHoliday(date, holidays) {

                const formatted = date.toISOString().split('T')[0];

                return holidays.includes(formatted);
            }

            /*
            ============================================
            CET CUTOFF
            ============================================
            */

            let baseDate = new Date();

            const cetHour = parseInt(
                new Intl.DateTimeFormat('en-US', {
                    timeZone: 'Europe/Copenhagen',
                    hour: 'numeric',
                    hour12: false
                }).format(new Date()),
                10
            );

            /*
            AFTER 14:00 CET
            START NEXT DAY
            */

            if (cetHour >= 12) {

                baseDate.setDate(baseDate.getDate() + 1);
            }

            /*
            ============================================
            SHIPPING DATE
            HOLIDAYS ONLY APPLY HERE
            ============================================
            */

            let shippingDate = new Date(baseDate.getTime());

            while (
                isWeekend(shippingDate) ||
                isHoliday(shippingDate, holidays)
            ) {
                shippingDate.setDate(shippingDate.getDate() + 1);
            }

            /*
            ============================================
            ADD BUSINESS DAYS
            ONLY SKIP WEEKENDS
            HOLIDAYS DO NOT AFFECT TRANSIT
            ============================================
            */

            function addBusinessDays(date, days) {

                const result = new Date(date.getTime());

                let added = 0;

                while (added < days) {

                    result.setDate(result.getDate() + 1);

                    /*
                    ONLY SKIP WEEKENDS
                    */

                    if (!isWeekend(result)) {

                        added++;
                    }
                }

                return result;
            }

            /*
            ============================================
            DELIVERY RANGE
            ============================================
            */

            const minDate = addBusinessDays(
                shippingDate,
                shippingRange.min
            );

            const maxDate = addBusinessDays(
                shippingDate,
                shippingRange.max
            );

            /*
            ============================================
            FORMAT
            ============================================
            */

            function formatDeliveryRange(minDate, maxDate, isCartDrawer = false) {

                const minMonth = minDate.toLocaleDateString(undefined, {
                    month: 'long'
                });

                const maxMonth = maxDate.toLocaleDateString(undefined, {
                    month: 'long'
                });

                const minDay = minDate.getDate();
                const maxDay = maxDate.getDate();

                /*
                BOLD MONTH + DATES
                */

                const formattedDate = (minMonth === maxMonth)
                    ? `<strong>${minMonth} ${minDay} – ${maxDay}</strong>`
                    : `<strong>${minMonth} ${minDay} – ${maxMonth} ${maxDay}</strong>`;

                const shipItem = [...document.querySelectorAll(".cart-items__table-row")].map(row => row.getAttribute("data-ship-item")).find(value => value);
                const arrivalDate = shipItem ? `<strong>${shipItem}</strong>` : formattedDate;

                /*
                DIFFERENT TEXT FOR CART
                */
                const ship_price = window.HBShippingThreshold.liquidPrice;
                const rates = {  USD: 200,EUR: 180, DKK: 900};
                const currentCode = Shopify.currency.active;
                const value = rates[currentCode] ?? rates.DKK;  

                const shippingText = ship_price == 0 ? `Free priority shipping - arrives ${arrivalDate}` : `Free shipping over <strong>${ship_price} ${currentCode}</strong> - arrives ${arrivalDate}`;
                
                const prefix = isCartDrawer
                     ? shippingText
                    : `Order now - arrives ${formattedDate}`;

                return `${prefix}`;
            }

           /*
            ============================================
            UPDATE PRODUCT PAGE
            ============================================
            */

            document.querySelectorAll('.product-delivery-date')
                .forEach(el => {
                    const text = formatDeliveryRange(
                        minDate,
                        maxDate,
                        false
                    );

                    if (el.innerHTML !== text) {

                        el.innerHTML = text;
                        el.style.opacity = '1';
                    }
                });

            /*
            ============================================
            UPDATE CART DRAWER
            ============================================
            */

            document.querySelectorAll('.cart-delivery-date')
                .forEach(el => {

                    const text = formatDeliveryRange(
                        minDate,
                        maxDate,
                        true
                    );

                    if (el.innerHTML !== text) {

                        el.innerHTML = text;
                        el.style.opacity = '1';
                    }
                });

                    } catch (error) {

                        console.error('Delivery Date Error:', error);

                    } finally {

                        isUpdating = false;
                    }
                }

    /*
    ============================================
    EVENTS
    ============================================
    */

    document.addEventListener(
        'DOMContentLoaded',
        updateDeliveryDate
    );

    document.addEventListener('cart:updated', () => {
        console.log("Updated");
        setTimeout(updateDeliveryDate, 200);
    });

    document.addEventListener('cart:added', () => {

        setTimeout(updateDeliveryDate, 500);
    });

    document.addEventListener('click', function(e) {

        if (
            e.target.closest(
                'a[href="/cart"], .cart-toggle, #cart-icon-bubble'
            )
        ) {
            setTimeout(updateDeliveryDate, 400);
        }
    });

    /*
    ============================================
    OBSERVER
    ============================================
    */

    const observer = new MutationObserver(() => {

        if (
            !isUpdating &&
            document.querySelector('.custom-delivery-date')
        ) {
            updateDeliveryDate();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

})();

// Toggle sticky gift button visibility based on section scroll position
const targetSection = document.querySelector(
  '.content-for-layout .section-wrapper:last-child'
);

const giftButton = document.querySelector('.gift-floating-btn');

if (targetSection && giftButton) {
  new IntersectionObserver(([entry]) => {
    giftButton.classList.toggle('is-active', entry.isIntersecting);
  }, {
    threshold: 0
  }).observe(targetSection);
}

document.addEventListener('click', function (event) {
    const freeBtn = event.target.closest('.add-to-cart-button.free-products');
    if (!freeBtn) return;
    document.querySelector('.gift-floating-btn').click();
  }
);
document.addEventListener('click', function (event) {
  const freepopUp = event.target.closest('.gift-popup-btn');
  if (!freepopUp) return;

  const giftFloatingBtn = document.querySelector('.gift-floating-btn');
  const cartCloseBtn = document.querySelector('.cart-drawer__close-button');

  if (giftFloatingBtn) {
    giftFloatingBtn.click();
  } else {
    console.warn('Gift floating button not found');
  }

  if (cartCloseBtn) {
    cartCloseBtn.click();
  } else {
    console.warn('Cart drawer close button not found');
  }
});
document.querySelector('#freeGiftToast')
  ?.addEventListener('click', function (event) {

    // Overlay par click hua
    if (event.target === this) {
      document.querySelector('.popup__close_threshold')?.click();

      // ya:
      // this.classList.remove('is-visible');
    }

});
document.querySelector('.facets--horizontal')?.addEventListener('click', function (e) {
  e.stopPropagation();
  this.classList.toggle('is-active');
});

function removeCheckedClassIfNoFilter() {
  if (!window.location.search.includes('filter')) {
    document
      .querySelectorAll('.mega-menu__list_color li.is-checked')
      .forEach((item) => item.classList.remove('is-checked'));
  }
}
function getCookie(name) {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [cookieName, ...cookieValue] = cookie.trim().split('=');

    if (cookieName === name) {
      return decodeURIComponent(cookieValue.join('='));
    }
  }

  return null;
}

window.addEventListener('load', function () {
  setTimeout(function () {
    document.querySelectorAll('.lazy-video').forEach(function (video) {
      if (video.dataset.src) {
        const source = document.createElement('source');
        source.src = video.dataset.src;
        source.type = 'video/mp4';

        video.appendChild(source);
        video.load();
        video.play().catch(() => {});
      }
    });

    const videos = document.querySelectorAll('.js-autoplay-video');
    let hasPlayed = false; // ✅ guard flag

    const playAllVideos = () => {
      if (hasPlayed) return; // 🚫 prevent multiple calls
      hasPlayed = true;

      videos.forEach(video => {
        video.play().catch(() => {});
      });
    };

    // First user interaction anywhere
    document.addEventListener('touchstart', playAllVideos, { once: true });
    document.addEventListener('click', playAllVideos, { once: true });
  }, 1500);




});


const dialogs = document.querySelector('#free-gift-dialog dialog');

dialogs?.addEventListener('click', (e) => {
  if (e.target === dialogs) {
    dialogs.close();
  }
});
